export var CustomerType;
(function (CustomerType) {
    CustomerType["HOUSEHOLD"] = "household";
    CustomerType["MICRO"] = "micro";
    CustomerType["SMALL"] = "small";
    CustomerType["MEDIUM"] = "medium";
    CustomerType["LARGE"] = "large";
})(CustomerType || (CustomerType = {}));
